// Source (board) marker colours by placement confidence.
export const CONFIDENT_SOURCE_FILL = "#f59e0b";
export const CONFIDENT_SOURCE_STROKE = "#7c2d12";
export const ESTIMATED_SOURCE_FILL = "#fb7185";
export const ESTIMATED_SOURCE_STROKE = "#9f1239";

// Corner badge colours: rose "!" for an estimated position, blue "i" for a riser entry.
export const ESTIMATED_BADGE_FILL = "#dc2626";
export const RISER_BADGE_FILL = "#2563eb";
export const BADGE_TEXT_FILL = "#ffffff";

// Blinking highlight marker (a device the user is locating on the plan).
export const HIGHLIGHT_COLOR = "#2563eb";

// Devices the panel is pointing at (ringed, nothing committed yet). It is a
// RING and nothing else: a routed device is already a filled disc with a
// concentric ring of its own hue, drawn at MARKER_OPACITY_AT_HIGH_ZOOM = 0.4,
// so a translucent disc with a centre dot was the same glyph in a different
// colour — "what are the circular markers?". A selection has no body, so it can
// only ever read as something drawn AROUND a device.
export const SELECTED_DEVICE_STROKE = "#1d4ed8";
// Deliberately neutral: a candidate is on OFFER, not chosen, and colouring it
// like a selection would make the two impossible to tell apart mid-pick.
export const CANDIDATE_DEVICE_STROKE = "#64748b";

// Removed-device marker (crossed-out red circle).
export const REMOVED_MARKER_FILL = "#fef2f2";
export const REMOVED_MARKER_STROKE = "#dc2626";

// Device that took no circuit. The run palette cycles twelve hues, so every
// hue is already on the plan and colour ALONE cannot separate these — the
// square does, because nothing else on this layer is anything but round. It is
// hollow for the same reason: a device with a run is a filled disc, so an empty
// outline says "nothing runs to this" without a word being read, and leaves the
// drawn symbol underneath legible where 191 of them land on real linework.
// Violet-600 is not removed-red, selection-blue, candidate-slate or board-amber.
// It is NOT clear of the run palette: #a855f7, #6366f1 and #d946ef all sit in
// this family, and at MARKER_OPACITY_AT_HIGH_ZOOM = 0.4 their device discs go
// pale — so the square is the only thing separating the two, and it has to.
export const UNROUTED_MARKER_STROKE = "#7c3aed";
/** Drawn wider and underneath, so the mark survives on top of dark linework. */
export const UNROUTED_MARKER_CASING = "#ffffff";

// Source markers stay fully opaque when zoomed out and dim when zoomed in so
// they never hide the plan underneath.
export const SOURCE_MARKER_OPACITY_AT_HIGH_ZOOM = 0.85;
export const BADGE_OPACITY_AT_HIGH_ZOOM = 0.8;

// A drawn wall. It is the one thing on this layer that is NOT a cable and not a
// device, so it may not be any of the colours above and it may not be a run hue:
// the twelve-hue run palette, board amber, removed red, selection blue,
// candidate slate and unrouted violet are all taken. Stone-700 is the colour of
// the thing itself — masonry — and it reads as heavier than anything carrying
// current, which is what a wall is to a cable.
export const WALL_COLOR = "#44403c";
export const SELECTED_WALL_STROKE = "#2563eb";

// A triangle, not a dot: a height change must read by shape against every cable colour.
export const HEIGHT_MARK_FILL = "#1e293b";
export const HEIGHT_MARK_CASING = "#ffffff";
